<script>
	import { getContext } from "svelte";
	import { callVerification } from "../Helpers/checkaddress.js";
	import LoadingSpinner from "../UI/LoadingSpinner.svelte";
	import { isEmpty } from "../Helpers/validation.js";
	import {
		INVALID,
		INVALID_ENTRY,
		INVALID_ENTRY_TIMEOUT_1,
		INVALID_ENTRY_TIMEOUT_2,
		REQUIRED_INFORMATION_MESSAGE,
	} from "../Helpers/constants.js";
	export let message;
	export let hasForm = false;
	export let blocked = false;
	export let onCancelPilot = () => {};
	export let onOkayPilot = () => {};
	const HFC_URL = HFC_API_URL;
	const TIMEOUT = 20000;
	const { close } = getContext("simple-modal");
	$: isSubmitted = blocked;
	let value = "";
	let promiseVerifyProgram = "";
	let display = "";
	let count = 0;
	let isSaveTriggered = false;
	const maxRetry = 5;
	let onChange = () => {};

	if (blocked) {
		display = INVALID_ENTRY_TIMEOUT_1 + maxRetry + INVALID_ENTRY_TIMEOUT_2;
		setTimeout(function () {
			isSubmitted = false;
			display = "";
		}, TIMEOUT);
	}

	function _onCancelPilot() {
		onCancelPilot(isSubmitted);
		close();
	}

	function _onOkayPilot(response, value) {
		onOkayPilot(response, value);
		close();
	}

	$: onChange(value);

	function verifyProgram() {
		isSaveTriggered = true;
		if (!isEmpty(value)) {
			isSubmitted = true;
			return (promiseVerifyProgram = callVerification(
				HFC_URL,
				"pilot",
				value
			));
		}
	}
	function validateResponse(response) {
		isSubmitted = false;
		if (response && response === INVALID) {
			count++;
			display = INVALID_ENTRY;
			if (count >= maxRetry) {
				isSubmitted = true;
				display =
					INVALID_ENTRY_TIMEOUT_1 +
					maxRetry +
					INVALID_ENTRY_TIMEOUT_2;
				setTimeout(function () {
					count = 0;
					isSubmitted = false;
					display = "";
				}, TIMEOUT);
			}
		} else {
			_onOkayPilot(response, value);
		}
		return "";
	}

	const init = (el) => {
		el.focus();
	};

	const onKeyPress = (e) => {
		if (e.charCode === 13) verifyProgram();
	};
</script>

<section class="section">
	<h2>{message}</h2>

	{#if hasForm}
		<input
			use:init
			type="tel"
			placeholder="########"
			bind:value
			on:keypress={(e) => onKeyPress(e)}
		/>
		{#if !value && isSaveTriggered}
			<p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
		{/if}
	{/if}
	<br />
	<section class="section">
		<div class="buttons">
			<button class="button is-danger is-light" on:click={_onCancelPilot}>
				Cancel
			</button>
			<button
				disabled={isSubmitted}
				class="button is-success"
				on:click={verifyProgram}
			>
				Continue
			</button>
			{#await promiseVerifyProgram}
				<LoadingSpinner />
			{:then response}
				{#if response}{validateResponse(response)}{/if}
			{/await}
			<div>
				<p>
					{#if display}
						<p class="error-message">{display}</p>
					{/if}
				</p>
			</div>
		</div>
	</section>
</section>

<style>
	h2 {
		font-size: 2rem;
		text-align: center;
	}
	input {
		width: 100%;
	}
	.buttons {
		display: flex;
		justify-content: space-between;
	}
	.error-message {
		color: red;
		margin: 0.25rem 0;
	}
</style>
